import { ExternalLink } from "lucide-react";

export const SignatureProfileFacebook = ({ profile }: { profile: any }) => {
  const facebook = Array.isArray(profile?.facebooks)
    ? profile.facebooks[0]
    : undefined;

  const profileTag: string | undefined = facebook?.profileTag || undefined;
  const visitLink: string | undefined = facebook?.visitLink || undefined;
  const posts: string[] = Array.isArray(facebook?.posts)
    ? (facebook.posts as string[]).filter(Boolean)
    : [];

  const hasHeader = Boolean(profileTag || visitLink);
  const hasPosts = posts.length > 0;

  if (!hasHeader && !hasPosts) return null;

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8">
          {/* 22. Signature profile facebook */}
          <div>
            <h2 className="font-playfair text-3xl font-bold mb-2">
              Recent Updates
            </h2>
            {profileTag ? (
              // eslint-disable-next-line react/jsx-one-expression-per-line
              <p className="text-muted-foreground">/{profileTag}</p>
            ) : null}
          </div>
          {visitLink ? (
            <a
              href={visitLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 text-primary-foreground h-10 px-4 py-2 mt-4 md:mt-0 rounded-full bg-[#1877F2] hover:bg-[#1877F2]/90"
            >
              <ExternalLink className="mr-2" size={18} />
              Visit Facebook Page
            </a>
          ) : null}
        </div>
        {/* 23. Signature profile facebook posts (embeded code) */}
        {hasPosts ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-5xl mx-auto">
            {posts.map((embed, idx) => (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={idx}
                className="rounded-lg border bg-card text-card-foreground shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: embed as string }}
              />
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default SignatureProfileFacebook;
